import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import InvestigatorClip from "./InvestigatorClip";
import { useEffect } from "react";
import { clipSrc, thumbSrc } from "../api/client";
import DragonPlayer from "./DragonPlayer";
// The one definition of the investigator player's React key. A new key means a
// fresh player mount; the investigator view tags play-state reports with it.
export function evidencePlayerKey(evidence, playToken = 0) {
    return `${evidence.investigation}:${evidence.source}:${evidence.offset}:${playToken}`;
}
// modal — overlay with backdrop + Escape key, used by Grid view's "click
//   thumb to play" interaction.
// inline — letterboxed 16:9 frame in StudioView's player column. No backdrop,
//   no close, no Escape (Studio's Esc is reserved for the customer-switch
//   banner per D11). Caller passes onError to surface clip-404 as an
//   empty-state glyph.
//
// Both modes now route through DragonPlayer (decision [#6]). The HUD is
// canvas-drawn by Playback using b2 SEI cameraName + timestamp (decision
// [#13]); the old .clip-hud DOM overlay is gone.
export default function ClipPlayer({ ev, onClose, mode = "modal", onError, evidence, evidenceLabel, playToken = 0, onEnded, onPlayingChange, onScrubChange, markers, onTimeUpdate, trimStartSec }) {
    // Escape only on modal — see header comment for why inline opts out.
    useEffect(() => {
        if (mode !== "modal" || !onClose)
            return;
        const onKey = (e) => { if (e.key === "Escape")
            onClose(); };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [mode, onClose]);
    if (evidence)
        return _jsx(InvestigatorClip, { evidence: evidence, label: evidenceLabel ?? null, onError: onError, onEnded: onEnded, onPlayingChange: onPlayingChange, onScrubChange: onScrubChange, markers: markers, onTimeUpdate: onTimeUpdate, trimStartSec: trimStartSec }, evidencePlayerKey(evidence, playToken));
    if (!ev)
        return null;
    // ADR-116: central events stream through the cloud media route; shard events
    // keep the per-customer clip alias.
    const src = clipSrc(ev);
    const poster = thumbSrc(ev);
    const playerKey = ev.central ? `${ev.customer}:${ev.central.media_ref}` : `${ev.customer}:${ev.bID}`;
    if (mode === "inline") {
        return (_jsx(DragonPlayer, { src: src, ev: ev, onError: onError, poster: poster }, playerKey));
    }
    return (_jsx("div", { className: "modal-backdrop", onClick: onClose, children: _jsxs("div", { className: "modal-clip", onClick: (e) => e.stopPropagation(), children: [_jsx("button", { className: "close", onClick: onClose, children: "\u00D7" }), _jsx(DragonPlayer, { src: src, ev: ev, onError: onError, poster: poster }, playerKey), _jsxs("div", { className: "clip-meta", children: [_jsx("span", { children: new Date(ev.tEventStart).toLocaleString() }), _jsxs("span", { children: ["cam ", ev.bCamera] }), _jsx("span", { children: ev.customer })] })] }) }));
}
